import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { LocaleUtil, StringUtil } from "@eres/core";
import { SSOApi } from "@eres/ssoapi";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { exToMessage } from "@eres/ssoapi/api";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { Step, Stepper } from "react-form-stepper";

import cfg from "@eres/ssoapi/config";
import { navigate, replaceNavigate } from "@my-dld/utils/StoreUtils";
import I8N from "@eres/core/dist/I8N";
import TextInputField from "@my-dld/components/Form/TextInputField";
import { getAppServices } from "@10x/coreapp";
import { getConsumerId } from "../../configApp";

interface State {
    application: any;
    selectedProfileId?: number;
	error: { [ k: string ]: string };
	arrNDA? : any[];
	arrCompletedSteps? : number[];
	activeStep: number;
	nameEn?: string;
	nameAr?: string;
	hasNDA?: boolean;
	isLoading?: boolean;
	emiratesId?: string;
	designationEn?: string;
	designationAr?: string;
	companyNameEn?: string;
	companyNameAr?: string;
	templateURL?: string;
	response?: any;

}

class ProfileNDA extends Component<RoutedViewProps, State> {

    constructor(props: any) {
        super(props);

	    const application = getAppServices().storeService.getStore().getState().User.application;
	    const selectedProfileId = getAppServices().storeService.getStore().getState().User.selectedProfileId;
        this.state = {
            application: application,
            selectedProfileId: selectedProfileId,
	        error: {},
	        arrNDA: [],
	        arrCompletedSteps: [],
	        activeStep: 0,
	        hasNDA: false,
	        isLoading: true,
        };
    }

    componentDidMount() {
	    const application = getAppServices().storeService.getStore().getState().User.application;
        // CALL API FROM ALI , if response is success , proceed with the below code
	    showLoading();
	    SSOApi.profile.fetchNDAs(application.id).then( r => {
			if (r.response.validationErrorsList && r.response.validationErrorsList.length) {
				showErrorMessage(r.response.validationErrorsList[0].errorMessage);
			} else {
				if (r.response ) {
					if (r.response.hasNDA) {
						this.selectProfile();
					} else {
						this.setState({ response: r.response,
							hasNDA: r.response.hasNDA,
							arrNDA: r.response.applicationUserProfiles ,
							nameAr : r.response.fullName.arabicName,
							nameEn : r.response.fullName.englishName,
							emiratesId: r.response.emiratesId ,
							isLoading: false,
							templateURL: cfg.ndaAPI().endPoint() + "/" + r.response.templateUrl + "?consumer-id=" + getConsumerId(cfg.ndaAPI().endPoint()) }, () => {
							this.onStepClicked(this.state.activeStep);
						});
					}

				}
			}
		    hideLoading();
	    })
	    .catch( e => {
		    hideLoading();
		    console.log("REACHED HERE");
		    return exToMessage( e )
		    .then( SSOApi.profile.handleProfileException )
		    .then( correction => {
			    console.log("REACHED HERE 1");
			    showErrorMessage(Strings.error);
			    const isCorrected = correction.action.task( correction.data );
			    if ( isCorrected ) {
					this.setState({isLoading: false});
				    hideLoading();
				    replaceNavigate( "/mydld/dashboard" );
			    }
			    return Promise.reject( correction.error );
		    } ).catch( e => {
			    console.log("REACHED HERE 2");
			    hideLoading();
			    exToMessage( e ).then( message => {
				    this.setState({isLoading: false});
				    hideLoading();
				    let key = "newPwd";
				    if ( message.src && message.src === "old" ) {
					    key = "current";
				    }
				    showErrorMessage(Strings.error);
				    replaceNavigate( "/mydld/dashboard" );
			    } );
		    } );

	    } );
    }

	onSubmitNDA = () => {
		this.state.response.applicationUserProfiles = this.state.arrNDA;
		// console.log("this.state.response", this.state.response);
		showLoading();
		SSOApi.profile.submitNDA(this.state.response).then( r => {
			console.log("SUBMIT RESPONSE", r);
			hideLoading();
			this.selectProfile();
		})
		.catch( e => {
			hideLoading();
			return exToMessage( e )
			.then( SSOApi.profile.handleProfileException )
			.then( correction => {
				const isCorrected = correction.action.task( correction.data );
				if ( isCorrected ) {
					this.setState({isLoading: false});
					hideLoading();
					// replaceNavigate( "/mydld/profile" );
				}
				return Promise.reject( correction.error );
			} ).catch( e => {
				hideLoading();
				exToMessage( e ).then( message => {
					this.setState({isLoading: false});
					hideLoading();
					let key = "newPwd";
					if ( message.src && message.src === "old" ) {
						key = "current";
					}
					// this.setError( key, message.error );
				} );
			} );
		} );
	}

	selectProfile = () => {
		if (this.state.selectedProfileId !== 0) {
			showLoading();
			// SSOProfile.getProfile()?.selectedUserAccountId!
			SSOApi.profile.selectProfile(  this.state.selectedProfileId + "" ).then( r => {
				const url = LocaleUtil.getLocalValue( this.state.application?.url );
				if ( url ) {
					hideLoading();
					if ( url.startsWith( "#" ) ) {
						let xp = url.substr( 1 );
						navigate( xp );
					} else {
						window.open( url + "?ln=" + I8N.locale(), "_" + this.state.application.id );
					}
				}
				replaceNavigate( "/mydld/dashboard" );
			} )
			.catch( e => {
				hideLoading();
				return exToMessage( e )
				.then( SSOApi.profile.handleProfileException )
				.then( correction => {
					const isCorrected = correction.action.task( correction.data );
					if ( isCorrected ) {
						hideLoading();
						// replaceNavigate( "/mydld/dashboard" );
					}
					return Promise.reject( correction.error );
				} ).catch( e => {
					hideLoading();
					exToMessage( e ).then( message => {
						hideLoading();
						let key = "newPwd";
						if ( message.src && message.src === "old" ) {
							key = "current";
						}
						// this.setError( key, message.error );
					} );
				} );

			} )
			.finally( () => {
				console.log("REACHING FINALLY --> ");
				const url = LocaleUtil.getLocalValue( this.state.application?.url );
				if ( url ) {
					hideLoading();
					if ( url.startsWith( "#" ) ) {
						let xp = url.substr( 1 );
						navigate( xp );
					} else {
						// replaceNavigate( "/mydld/profile" );
						window.open( url + "?ln=" + I8N.locale(), "_" + this.state.application.id );
					}
				}
				replaceNavigate( "/mydld/dashboard" );
			});
		}
	}
	onIAgree = () => {
		if (this.isChecked()) {
			let arrCompletedSteps = this.state.arrCompletedSteps;
			arrCompletedSteps?.push( this.state.activeStep);
			if ( this.state.arrNDA ) {
				let profile = this.state.arrNDA[this.state.activeStep];
				profile.name.englishName = this.state.companyNameEn;
				profile.name.arabicName = this.state.companyNameAr;
				profile.designation.englishName = this.state.designationEn;
				profile.designation.arabicName = this.state.designationAr;
				profile.checked = true;
			}

			if ( this.state.arrNDA ) {
				let profile = this.state.arrNDA[this.state.activeStep];
				console.log("profile", profile);
				const error: { [ k: string ]: string } = {};
				let isValid = true;
				if (this.state.companyNameEn?.toLowerCase() !== "n/a") {
					if ( StringUtil.isEmptyStringOrNull( profile.designation.englishName ) ) {
						error.designationEn = LocaleUtil.getLocalValue(Strings.required, "en");
						isValid = false;
					}
				}

				if (this.state.companyNameAr?.toLowerCase() !== "n/a") {
					if ( StringUtil.isEmptyStringOrNull( profile.designation.arabicName ) ) {
						error.designationAr = "مطلوب";
						isValid = false;
					}
				}


				if (isValid) {
					this.setState({arrCompletedSteps: arrCompletedSteps}, () => {
						console.log("Submit now", this.state.activeStep, this.state.arrNDA?.length);
						if ( this.state.arrNDA && this.state.arrNDA.length) {
							if (this.state.activeStep  === this.state.arrNDA?.length - 1) {
								// SUBMIT
								this.onSubmitNDA();

							} else {
								this.setState({activeStep: this.state.activeStep + 1 }, () => {
									this.onStepClicked(this.state.activeStep);
								});
							}
						}

					});
				}
				this.setState( {
					error: error,
				} );
			}

		}
	};

	onChecked = () => {
		if ( this.state.arrNDA ) {
			let profile = this.state.arrNDA[this.state.activeStep];
			if (profile.checked) {
				profile.checked = false;
			} else {
				profile.checked = true;
			}
		}
		this.setState({arrNDA: this.state.arrNDA});
	}

	isChecked = () => {
		if ( this.state.arrNDA ) {
			let profile = this.state.arrNDA[this.state.activeStep];
			return profile?.checked;
		}
		return false;
	}

	onStepClicked = (stepNo: number) => {
		if ( this.state.arrNDA ) {
			let profile = this.state.arrNDA[stepNo];
			this.setState({companyNameEn: profile.name.englishName,
				companyNameAr: profile.name.arabicName,
				designationEn: profile.designation.englishName,
				designationAr: profile.designation.arabicName,
				activeStep: stepNo },
			);
		}
	}

	isFieldDisabled = () => {
		let value = false;
		if (this.state.companyNameEn && this.state.companyNameEn.length ) {
			if (this.state.companyNameEn.toLowerCase() === "n/a") {
				value = true;
			}
		}

		if (this.state.companyNameAr && this.state.companyNameAr.length ) {
			if (this.state.companyNameAr.toLowerCase() === "n/a") {
				value = true;
			}
		}
		return value;
	}

    render() {
        return ( <>
	        <div className="container pt-4">
		        { !this.state.isLoading && !this.state.hasNDA && <div className="nda-stepper fs-6">
			        <div className="nda-letter-msg">

                        <><span>Please provide your designation and agree to the “non-disclosure acknowledgment of confidential information” to continue using the DLD systems.</span><span>يرجى تقديم مسمى وظيفتك والموافقة على  "إقرار تعهد ضمان السرية الإفصاح عن المعلومات"  للاستمرار استخدام أنظمة في دائرة الأراضي والأملاك.</span></>

			        </div>
			        <div className="nda-main-header">

			        { this.state.arrNDA && this.state.arrNDA.length > 1 && <Stepper
					        activeStep={ this.state.activeStep }
					        style={ {} }>
					        { this.state.arrNDA && this.state.arrNDA.map( ( item, index ) => {
						        const profileName = Strings.profile + " " + ( index + 1 );
						        return <Step
							        // completed={ this.stepCompleted(index + 1) }
							        label={ profileName }
							        onClick={ () => {
								        this.onStepClicked( index );
							        } }
							        styleConfig={ {
								        activeBgColor: "#e7ac0f",
								        activeTextColor: "#ffffff",
								        completedBgColor: "#00893e",
								        completedTextColor: "#ffffff",
								        inactiveBgColor: "#eeeeee",
								        inactiveTextColor: "#ffffff",
								        size: 30,
								        circleFontSize: 14,
								        labelFontSize: 14,
								        borderRadius: 15,
								        fontWeight: 10,
							        } }/>;
					        } ) }
				        </Stepper> }
				        <div className="nda-letter card dld-content-text nda-user-detail">
					        <div className="row row-cols-1 row-cols-lg-2">
						        <div className="col">
							        <div className="card-title title-nda">Non-Disclosure acknowledgement of Confidential Information</div>
						        </div>
						        <div className="col direction-rtl">
							        <div className="card-title title-nda">إقرار تعهد ضمان السرية وعدم الإفصاح عن المعلومات</div>
						        </div>
						        <div className="col">
							        <div className="card-body pt-0 pb-0">
                                        <div className="mb-3">
                                            <div className="nda-name-id"> I, <span className="name-user-s">
                                        { this.state.nameEn }</span> the undersigned, holding ID No.
									        <span className="id-user-s">{this.state.emiratesId}</span> and working as:
                                                </div>
                                            <TextInputField
                                                disabled={this.isFieldDisabled()}
                                                containerClassName={"field-style job-title-user"}
                                                label={Strings.enter_designation}
                                                id={"designationEn"}
                                                holder={this}
                                                type={"english"}
                                                required={true}
                                                error={this.state.error.designationEn}
                                                //placeHolder={ Strings.enter_designation }
                                                inputClassName={"form-control form-control-sm"}
                                                onValueChange={(e) => {
                                                    console.log("designationEn vv", e);
                                                    this.setState({ designationEn: e });
                                                }}
                                            />
                                            <span>at: <span className="nda-company-name" id={"companyNameEn"}>{this.state.companyNameEn}</span> in partnership with Dubai Land Department:</span>
								        </div>
							        </div>
						        </div>
						        <div className="col direction-rtl">
							        <div className="card-body pt-0 pb-0">
                                        <div className="mb-3">
                                            <div className="nda-name-id">
									        أنا، <span className="name-user-s">{ this.state.nameAr }</span> الموقع أدناه وأحمل هوية رقم
									        <span className="id-user-s">{this.state.emiratesId}</span> وأعمل بوظيفة:
                                                </div>
                                            <TextInputField
                                                disabled={this.isFieldDisabled()}
                                                containerClassName={"field-style job-title-user"}
                                                label={"أدخل التعيين"}
                                                id={"designationAr"}
                                                holder={this}
                                                type={"arabic"}
                                                required={true}
                                                extraInputClassName={"ar-text"}
                                                error={this.state.error.designationAr}
                                                //placeHolder={ "أدخل التعيين" }
                                                inputClassName={"form-control form-control-sm"}
                                                onValueChange={(e) => {
                                                    this.setState({ designationAr: e });
                                                }}
                                            />
                                            <span>لدى: <span className="nda-company-name" id={"companyNameAr"}>{this.state.companyNameAr}</span> والتي علاقتها مع دائرة الأراضي والأملاك في دبي:</span>
								        </div>

							        </div>
						        </div>
					        </div>
				        </div>
			        </div>
			        <div className="nda-letter card dld-content-text">
				        <div className="nda-iframe-wraper">
					        <iframe
						        src={ this.state.templateURL! }
						        height={ "100%" } width={ "100%" } className="nda-iframe" scrolling="auto" onLoad={ () => {
					        } }/>
				        </div>

				        <div className="content-footer">
					        <hr/>
					        <div className="ps-3 pe-3">
						        <div className="form-check">
							        <input
								        className="form-check-input" type="checkbox" value="" id="flexCheckDefault" onClick={ this.onChecked }
								        checked={ this.isChecked() }/>
							        <label className="form-check-label mb-0" htmlFor="flexCheckDefault">
								        This is an acknowledgement and pledge from me, of my own free will, to accept all the obligations,
								        conditions and controls contained in this acknowledgement and to do everything stated in it,
								        without the acknowledgement recipient bearing any responsibility or other consequences towards me
								        and/or towards others. This is an acknowledgement and pledge from me to fully abide by all the
								        terms and controls of what is stated herein, voluntarily and without coercion.<br/>
								        <span className="direction-rtl d-block">هذا إقرار وتعهد مني وأنا بكامل إرادتي، بقبول كافة الالتزامات والشروط والضوابط الواردة في هذا الإقرار والتعهد والعمل بكل ما جاء فيه، دون أن يتحمل المقر له أي مسؤولية أو تبعات أخرى تجاهي و/أو تجاه الغير. وهذا إقرار وتعهد مني بالالتزام الكامل بكافة الشروط والضوابط التي جاءت في هذا الإقرار بكامل إرادتي ودون إكراه.</span>
							        </label>
						        </div>
					        </div>


					        { this.isChecked() && <>
						        <hr/>
						        <div className="text-center">
							        <button
								        className="btn btn_style1 sw-btn-next sw-btn btn_1  " id="btn-sso-proceed"
                                        onClick={this.onIAgree}>
                                        {/*I8N.isRTL() ? "أنا موافق" : "I Agree"*/}
                                        I Agree / أنا موافق
							        </button>
						        </div>
					        </> }
				        </div>
			        </div>
		        </div> }
	        </div>
        </> );
    }

	private onContinue = () => {

	};


}

export default ProfileNDA;
